import { forwardRef } from 'react'
import { cn } from '@utils/cn'

const Input = forwardRef(
  (
    {
      className,
      type = 'text',
      label,
      error,
      icon: Icon,
      iconPosition = 'left',
      leftIcon: LeftIcon,
      rightIcon: RightIcon,
      ...props
    },
    ref
  ) => {
    const baseStyles =
      'w-full px-4 py-2 border rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100'

    const errorStyles = error
      ? 'border-red-500 focus:ring-red-500'
      : 'border-gray-300 dark:border-gray-600'

    const hasLeft = Boolean(LeftIcon) || (Boolean(Icon) && iconPosition === 'left')
    const hasRight = Boolean(RightIcon) || (Boolean(Icon) && iconPosition === 'right')
    const iconPaddingStyles = `${hasLeft ? 'pl-10' : ''} ${hasRight ? 'pr-10' : ''}`.trim()

    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            {label}
          </label>
        )}
        <div className="relative">
          {(LeftIcon || (Icon && iconPosition === 'left')) && (
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              {(LeftIcon || Icon) && (LeftIcon ? <LeftIcon className="h-5 w-5 text-gray-400" /> : <Icon className="h-5 w-5 text-gray-400" />)}
            </div>
          )}
          <input
            ref={ref}
            type={type}
            className={cn(baseStyles, errorStyles, iconPaddingStyles, className)}
            {...props}
          />
          {(RightIcon || (Icon && iconPosition === 'right')) && (
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
              {(RightIcon || Icon) && (RightIcon ? <RightIcon className="h-5 w-5 text-gray-400" /> : <Icon className="h-5 w-5 text-gray-400" />)}
            </div>
          )}
        </div>
        {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
      </div>
    )
  }
)

Input.displayName = 'Input'

export default Input
